import { render, staticRenderFns } from "./PainelIntegridade.vue?vue&type=template&id=3961adc4"
import script from "./PainelIntegridade.vue?vue&type=script&lang=js"
export * from "./PainelIntegridade.vue?vue&type=script&lang=js"
import style0 from "./PainelIntegridade.vue?vue&type=style&index=0&id=3961adc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports